import axios from "axios";

export interface UpdateVisiteurPayload {
  Nom_Complet: string;
  Tele: string;
  Adresse: string;
  EmailAccount: string;
  Password?: string;
}

const UpdateVisiteurService = (id: string, payload: UpdateVisiteurPayload) => {
  const url = `${process.env.REACT_APP_PHP_APP_URL}/visiteur/${id}/update`;
  return axios.post(url, payload, {
    headers: { "Content-Type": "application/json" },
  });
};

export default UpdateVisiteurService;
